module.exports = __webpack_public_path__ + "img/hhnm_gallery3.78fd90e5.jpg";